export default __webpack_public_path__ + "static/media/flag-syria.339f6c89.svg";